// extracted by mini-css-extract-plugin
export var card = "_au-0";
export var failedIcon = "_au-4";
export var failedIconBadge = "_au-3";
export var icon = "_au-1";
export var successIcon = "_au-2";